export class KisilerDraft {
    constructor(form) {
        this.tc = form.querySelector("[name=tc]")?.value.trim() ?? "";
        this.first_name = form.querySelector("[name=first_name]")?.value.trim() ?? "";
        this.last_name = form.querySelector("[name=last_name]")?.value.trim() ?? "";
        this.kisi_departman_id = Number(form.querySelector("[name=kisi_departman_id]")?.value) || null;
        this.unvan_id = Number(form.querySelector("[name=unvan_id]")?.value) || null;
    }

    toPayload() {
        return {
            tc: this.tc,
            first_name: this.first_name,
            last_name: this.last_name,
            kisi_departman_id: this.kisi_departman_id,
            unvan_id: this.unvan_id,
        };
    }
}
